// extracted by mini-css-extract-plugin
export default {"TooltipIconButton":"TooltipIconButton_TooltipIconButton__5wRo-","letterButton":"TooltipIconButton_letterButton__aP9pD"};